import React from "react";
import { styled } from "goober";

const TagLine = styled("span")`
  padding-left: var(--sp-2);
  color: var(--shade0-75);
`;

export default function RiotIDHeaderTitle({ gameName, tagLine }) {
  return (
    <>
      <span className="type-page-header">{gameName}</span>
      {tagLine && <TagLine className="type-page-subheader">#{tagLine}</TagLine>}
    </>
  );
}
